import { memo, useCallback } from 'react';

import { FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type DuplicateAssetTask, type GetBaseMetadata } from '~/store/tasks/types';

export type DuplicateAssetTaskFailedPanelItemProps = {
  localTaskId: string;
  metadata: Pick<GetBaseMetadata<DuplicateAssetTask>, 'isFile'>;
  onClear: (localTaskId: string) => void;
};

export const DuplicateAssetTaskFailedPanelItem = memo(
  ({ localTaskId, metadata: { isFile }, onClear }: DuplicateAssetTaskFailedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const itemLabel = isFile ? 'file' : 'asset';
    const handleClear = useCallback(() => onClear(localTaskId), [localTaskId, onClear]);
    const title = ui2026 ? `Couldn’t duplicate ${itemLabel}` : `Failed to duplicate ${itemLabel}!`;

    return (
      <PaneItemTW
        avatar={<FileStatusIconErrored size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{title}</FileStatusTitle>}
        buttons={<TaskPaneDismissButton label="Clear" onClick={handleClear} />}
      />
    );
  },
);

DuplicateAssetTaskFailedPanelItem.displayName = 'DuplicateAssetTaskFailedPanelItem';
